import { UserInfo, UserKind, UserKindLabel } from '@models/user';

export const groupAdditionalFixers = (secondaryFixers: UserInfo[]) => {
    const grouped: Record<string, string[]> = {
        [UserKind.DistributionList]: [],
        [UserKind.Person]: [],
    };
    secondaryFixers.forEach(({ kind, fullName, email }) => {
        const key = kind;
        grouped[key].push(`${fullName} (${email})`);
    });

    return Object.entries(grouped).map(([group, items]) => ({
        group: UserKindLabel[group],
        items,
    }));
};
